module.exports = __webpack_public_path__ + "static/1190433344.e6ad0ee6.jpg";